import { render, staticRenderFns } from "./PageAiQuestionary.vue?vue&type=template&id=d89a4064&"
import script from "./PageAiQuestionary.vue?vue&type=script&lang=ts&"
export * from "./PageAiQuestionary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports